import React from 'react';
import { createUseStyles } from 'react-jss';
import { default as ReactModal } from 'react-modal';
import Element from './element';
import Flex from './flex';
import Text from './text';
import { ReactComponent as CloseSVG } from '../assets/icons/close.svg';

const useStyles = createUseStyles({
  modal: {
    width: '80%',
    margin: 'auto'
  }
});

const Modal = ({
  containerClass,
  headerLabel,
  closable,
  className,
  children,
  onClose,
  width,
  height,
  ...rest
}) => {
  return (
    <ReactModal
      isOpen
      {...rest}
      style={{
        overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
        content: {
          width: width || '80%',
          margin: 'auto',
          height: height || '80%'
        }
      }}
    >
      <div className={containerClass}>
        <Flex justify="space-between" align="center">
          <Element
            type={Text}
            attrs={{ family: 'GTAM', size: '21px' }}
            marginBottom="15px"
          >
            {headerLabel}
          </Element>
          {/* {closable && <img src="" alt="close" onClick={onClose} />} */}
          {closable && (
            <Element
              type={CloseSVG}
              width="12px"
              height="12px"
              cursor="pointer"
              attrs={{ onClick: onClose }}
            />
          )}
        </Flex>
        {children}
      </div>
    </ReactModal>
  );
};

export default Modal;
